export const paymentReducer = (
  state = { payments: null, paymentDetail: null, loading: false, error: null },
  action
) => {
  switch (action.type) {
    case "GET_PAYMENTS_LIST_REQUEST": {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }
    case "GET_PAYMENTS_LIST_SUCCESS": {
      return {
        ...state,
        loading: false,
        payments: action.payload,
        error: null,
      };
    }
    case "GET_PAYMENTS_LIST_FAILED": {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }
    case "GET_PAYMENTS_REQUEST_LIST_REQUEST": {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }
    case "GET_PAYMENTS_REQUEST_LIST_SUCCESS": {
      return {
        ...state,
        loading: false,
        paymentsRequest: action.payload,
        error: null,
      };
    }
    case "GET_PAYMENTS_REQUEST_LIST_FAILED": {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }
    case "GET_PAYMENT_VIEW_REQUEST": {
      return {
        ...state,
        loading: true,
        error: null,
        paymentDetail: null,
      };
    }
    case "GET_PAYMENT_VIEW_SUCCESS": {
      return {
        ...state,
        loading: false,
        paymentDetail: action.payload,
        error: null,
      };
    }
    case "GET_PAYMENT_VIEW_FAILED": {
      return {
        ...state,
        loading: false,
        error: action.payload,
        paymentDetail: null,
      };
    }
    case "UPDATE_STATUS_REQUEST": {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }
    case "UPDATE_STATUS_SUCCESS": {
      return {
        ...state,
        loading: false,
        error: null,
      };
    }
    case "UPDATE_STATUS_FAILED": {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }
    default:
      return state;
  }
};
